import { useContext } from 'react';
import { SegmentsContext } from 'Common/providers/Segments';

const useSegments = () => {
    const segments = useContext(SegmentsContext);
    return { ...segments };
};

export default useSegments;
